import { StateSchema } from 'app/config/storeConfig/types';

export const getOfferNote = (state: StateSchema): Nullable<string> => state.sendOfferModal.note;
